// extracted by mini-css-extract-plugin
module.exports = {"cookieConsentOverlay":"CookieConsent-module--cookie-consent-overlay--1OT3W","flexContainer":"CookieConsent-module--flex-container--3MMix"};